import { List } from '../List'

export class BibliographyParent extends List {
  constructor(obj) {
    super(Bibliography, obj)
  }
}

export class Bibliography {
  constructor(obj) {
    this.id = obj?.id || null
    this.name = obj?.name || null
  }

  getForAPI() {
    return {
      id: this.id,
      name: this.name
    }
  }
}
